import { render, staticRenderFns } from "./debug1.vue?vue&type=template&id=1daf02b0&scoped=true"
import script from "./debug1.vue?vue&type=script&lang=js"
export * from "./debug1.vue?vue&type=script&lang=js"
import style0 from "./debug1.vue?vue&type=style&index=0&id=1daf02b0&prod&lang=scss&scoped=true"
import style1 from "./debug1.vue?vue&type=style&index=1&id=1daf02b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf02b0",
  null
  
)

export default component.exports